export function calcFontColor(hexColor) {
  // Ensure the hex color is valid
  if (!hexColor || typeof hexColor !== 'string' || !/^#([0-9A-F]{3}){1,2}$/i.test(hexColor)) {
    return 'inherit'; // Default to inherit/dark for invalid input
  }

  // Expand shorthand hex codes (e.g., #abc to #aabbcc)
  if (hexColor.length === 4) {
    hexColor = '#' + hexColor[1] + hexColor[1] + hexColor[2] + hexColor[2] + hexColor[3] + hexColor[3];
  }

  // Convert hex to RGB
  const r = parseInt(hexColor.substring(1, 3), 16);
  const g = parseInt(hexColor.substring(3, 5), 16);
  const b = parseInt(hexColor.substring(5, 7), 16);

  // Calculate luminance (perceived brightness)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Use white for dark backgrounds, default/dark for light backgrounds
  return luminance > 0.5 ? 'inherit' : '#FFFFFF';
}